export const pathToScreenNameMap: Record<string, string> = {
  '/': 'home',
  '/machine-range/:id': 'range',
  '/machine/:id': 'machine',
  '/settings': 'settings',
};

export function getScreenNameFromPath(path: string): string | null {
  for (const route in pathToScreenNameMap) {
    const routePattern = new RegExp('^' + route.replace(/:\w+/g, '\\w+') + '$');
    if (routePattern.test(path)) {
      return pathToScreenNameMap[route];
    }
  }

  return null;
}
